import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';

import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from "../../common/AbstractListView";
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import { CurrencyAmountRenderer, DateRenderer, DateTimeRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextAlignRightRenderer, TextRenderer } from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../uiControls/CurrencyLabel';
import {getJobNameFromInvBillCrDbJobType, JobNames} from "../../../framework.core/JobNames";
import {generalBillList} from "../tableSettings";
import {BillListItem} from "../../../fms.data/models/BillListItem";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import IfmsModal from "../../../ui/IfmsModal";
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { DraftFilterRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import BillInformation from '../../reports/BillInformation';
import fastStorage from '../../../fastStorage';
import { nowDate } from '../../../dateUtils';
import VendorBalanceDetails from '../../reports/AccountBalance';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { getFmsGlobal } from '../../../globals';
import * as XCol from "../../../framework.core/XExportColumn";
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import { FormType, SecType } from '../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';
import PrintBill from '../../accounting/bill/report/PrintBill';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus } from '@fortawesome/free-solid-svg-icons';
import { BalanceIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { useJournal } from '../general/journal/JournalListView';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import CheckBoxIcon from '../../../ui/CheckBoxIcon';
import { SearchModelBase } from '../../../fms.data/models/SearchModelBase';

function IndicatorRenderer({ data, row}:any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  //if (lStatus === 'PC') dataTooltip = 'Period Close';

  function onIndicatorClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(data[row.index].id);
  }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;


  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px'}} onClick={onIndicatorClick}>{content}</div>
    <div
      className="ifms-table-default"
      id={`ifms-table-default-${row.index}`}
      data-tooltip={'Bill Information'}
      style={{ width: '100%', minHeight: '22px', cursor: 'pointer' }}
      onClick={onIndicatorClick}>
      {content}
    </div>
  );
}

function DraftRenderer({cell}:any) {
  // if (cell && cell.value) {
  //   return (
  //     <div data-tooltip={'Draft'} className="ifms-table-default">
  //       <span style={{color: 'green'}}>V</span>
  //     </div>
  //   );
  // }
  
  // return <div className="ifms-table-default"></div>;

    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${cell.row.index}`} className="ifms-table-default" data-tooltip={'Draft'}>
        <CheckBoxIcon value={true} />
      </div>;  
    }
  
    return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function VoidRenderer({cell}:any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{color: 'red'}}>V</span>
      </div>
    );
  }
  
  return <div className="ifms-table-default"></div>;
}

function ConfirmedRenderer({ value, row }: any) {
  
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();



    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.GBill] : null;
    if (!secCont) {
      secCont = [{ secCntr: FmsSecCntr.GBillGivCredit, contName: 'cmdNew11' },
      { secCntr: FmsSecCntr.GBillCancelCredit, contName: 'cmdNew13' },
      { secCntr: FmsSecCntr.GBillConfirmed, contName: 'chkConfirmed' }
    ];

      appContext.setSecurityControls(JobNames.GBill, secCont);
    }
  

  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setBillConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(JobNames.GBill, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Bill has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Bill has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Bill is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    
  </div>;
}

function useSelectedOperations() {
  const fmsGlobal = getFmsGlobal();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralBill/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `/${operation}/acGeneralBill/add`, NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralBill/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/${operation}/acGeneralBill/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close Bill first', false, null, "warning");
    //   return;
    // }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        {selectedElement.draft && <h3>Delete will remove draft data permanently.</h3>}
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.GBill, { id:selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/${operation}/acGeneralBill/edit/${selectedElement.id}`;
        const viewUrl = `/${operation}/acGeneralBill/view/${selectedElement.id}`;
        if ( jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewUrl)) {
          context.resetForCurrentJob();
          removeSingleJobMenuinTab(jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editUrl) ? editUrl : viewUrl,'');
        }
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acGeneralBill/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralBill/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acGeneralBill/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acGeneralBill/edit/${id}`;
    const viewUrl = `/${operation}/acGeneralBill/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGBillList, selectedElement.branch);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acGeneralBill/add?copyId=${id}`, NavigationType.newPage);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.GBill;
    const jobType = selectedElement.jobType;

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }


  async function switchToPayment(){
    if (!selectedElement) {
      return;
    }

    const tbName = 'T_APHD';
    const apiResult = await appContext.api.getPaymentIds(tbName,selectedElement.id);
    if(apiResult && apiResult.result){
      const paymentDataInfos = apiResult.result;     
      let model = new SearchModelBase();
      let link = '';
      if(paymentDataInfos.length === 0){
        await showGlobalOkDialog(<p>This G.Bill has not been paid!</p>);
        return;
      }

      let cpayIds = paymentDataInfos.filter((item: any) => item.Type === "D").map((item: any) => item.DepoHdId).join(','); 
      let bpayIds = paymentDataInfos.filter((item: any) => item.Type === "C").map((item: any) => item.DepoHdId).join(','); 
      const cPaySec = findSecurityTask(appContext, FmsSecTask.AcctCustPayment);
      const bPaySec = findSecurityTask(appContext, FmsSecTask.AcctBillPayment);

      if(cPaySec.grantRead && cpayIds.length > 0) {
        link = '/common/joblistview/acCustomerPayment/accounting';
        model.extraWhere = `Id in (${cpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      }

      if(bPaySec.grantRead && bpayIds.length > 0) {
        link = '/common/joblistview/acBillPayment/accounting';
        model.extraWhere = `Id in (${bpayIds})`;
        jobListContext.setFilterForScreenExternally(link,'','','Payments','',false,true,model);
        openNewPage(history, link, NavigationType.newPage);
      } 
    }
  }
  return { create, deleteItem, edit, view, copy, operation, viewPaymentHistory, switchToPayment };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, switchToPayment } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  // const isDraft = jobListContext.selectedElement.draft;
  const selectedElement = jobListContext.selectedElement as BillListItem;

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGBillList, selectedElement?.branch);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd},
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Bill Information', shortcut: '', separator: false},
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel},
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to Pay List', shortcut: 'F7', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="gBill-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function openBillInformation() {
    if (jobListContext.rowExtrasId) {
      return;
    }
    jobListContext.setRowExtrasId(selectedElement.id);
  }

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        openBillInformation();
        break;
      case 4:
        deleteItem();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToPayment();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:  
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  //  const jobListContext = useContext(JobListViewContext);
  //  const selectedElement = jobListContext.selectedElement as BillListItem;
  //  const {switchJournal} = useJournal();
  //  const appContext = useContext(ApplicationContext);
  
  // if ((!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@'))) {
  //   return null;
  // }

  //  return (
  //    <JournalIconButton onClick={()=> switchJournal(JobNames.GBill, selectedElement.id, "", null, selectedElement.vendorName)} useText/>
  //  );

  return null;
  
 }

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const {deleteItem, edit, view, operation, copy,/* viewPaymentHistory */ } = useSelectedOperations();
  const {switchJournal} = useJournal();

  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGBillList, selectedElement?.branch);
  // const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  // const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);
  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@');

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/view/${id}`);
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/add`);
  }

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const disablePrint = hasSelectedRow && selectedElement.draft;


  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  // async function onCustomerBillAction(item: ActionButtonItem) {
  //   let link = '';
  //   switch (item.index) {
  //     case 0:
  //       link = `/accounting/acCustomerPayment/add`;
  //       break;
  //     case 1:
  //       link = `/accounting/acBillPayment/add`;
  //       break;
  //     case 2:

  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null );
  //       openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
  //       return;
  //     case 3:
  //     jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
  //       'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null);
  //       openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
  //       return;
  //   }
    
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
  //     await showGlobalOkDialog(<p>Payment New Operation is already in progress.</p>);
  //     return;
  //   }

  //   openNewPage(history, `${link}/${selectedElement.vendorId}`, NavigationType.newPage);
  // }

  async function vendorBalance() {
    if (selectedElement.vendorId <= 0 && (selectedElement.vendorName === null || selectedElement.vendorName === '')) {
      await showGlobalOkDialog(<p>You didn't enter Vendor.</p>, false, null, 'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <VendorBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.GBill}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={selectedElement.billDate??nowDate()}
          comId={selectedElement.vendorId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.vendorName}
        />
    })
  }

  return (
      <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='gBill-list-add-button' display="primary" link={`/${operation}/acGeneralBill/add`} disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='gBill-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='gBill-list-view-button' disabled={!hasSelectedRow} onClick={view} useText iconHeight='26px' />
        <DeleteIconButton2 name='gBill-list-delete-button' disabled={!canBeDeleted} onClick={deleteItem} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrintIconButton name='billings-gBill-list-print-button' disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'Print Bill', popupComponent: <PrintBill selectedElement={selectedElement} /> })} useText />
        {hasSecBal && (
          <BalanceIconButton
            name='gBill-list-vendorBalance-button'
            disabled={!hasSelectedRow}
            onClick={vendorBalance}
            useText />
        )}
      </div>
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='gBill-list-copy-button' disabled={!canBeCopied || disablePrint} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.GBill, selectedElement.id, "", null, selectedElement.vendorName)} useText/> }
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BillListItem;

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctGBillList, selectedElement?.branch);
  const history = useHistory();

  const {copy, create, edit, view, switchToPayment} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }  else if (unprocessedFkey === "F7") {
      switchToPayment();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8','F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.GBill}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as BillListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as BillListItem;
//   const appContext = useContext(ApplicationContext);
//   const listSec = findSecurityTask(appContext, FmsSecTask.AcctGBillList);
//   const [showGlobalOkDialog] = useGlobalOkDialog();
//   const history = useHistory();
//   const operation = 'accounting';

//   const hasSelectedRow = !!selectedElement;
//   const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
//   const disablePrint = hasSelectedRow && selectedElement.draft;

//   function hasOpenedNew() {
//     return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/add`);
//   }

//   async function copy() {
//     if (!selectedElement) {
//       return;
//     }

//     if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acGeneralBill/add`)) {
//       await showGlobalOkDialog(<p>New operation is already in progress.</p>);
//       return;
//     }

//     const id = selectedElement.id;
//     openNewPage(history, `/${operation}/acGeneralBill/add?copyId=${id}`, NavigationType.newPage);
//   }

//   return (
//     <>
//       <PrimaryButton name='gBill-list-copy-button' disabled={!canBeCopied || disablePrint} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
//     </>
//   )
    return  null;
 }

/**
 * Concrete implementation for Quotation List screen
 *
 * @class GeneralBillListView
 * @extends {AbstractListView}
 */
class GeneralBillListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const searchModel = BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void']);
    const apiResult = await api.getListItems(
      JobNames.GBill,
      'BillListItem',
      searchModel,
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: BillListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number, opType: string | undefined): Promise<Array<any>> {
    const searchModel = BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void']);
    const apiResult = await api.getListItems(JobNames.GBill, 'BillListItem',
      searchModel,
      pageNum,
      limit,
      pageSize,
      pagePerBatch
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return BillListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      // },
      // {
      //   accessor: 'draft',
      //   renderer: DraftFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v === 'D' ? true : false,
      // },
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType: string, systemSettings: SystemSettings, suntekSettings: SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    return BillListItem.getExportCollection(JobNames.GBill, useBranch, useVat, usebillingsTabVersion1).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      } else if (x.dataIndex === "draft") {
        colRenderer.Cell = DraftRenderer;
        //colRenderer.Cell = NullableCheckboxIconRenderer;
      // } else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
        
      }  else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      }else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex ==="vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      } else if (x.dataIndex === "refNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
        colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
        colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
        colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
        colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
        colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
        colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
        colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])} });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'billDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  generalBillList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    const usebillingsTabVersion1 = suntekSettings?.company?.billingsTabVersion === 1;
    const cols = BillListItem.getExportCollection(JobNames.GBill, useBranch, useVat, usebillingsTabVersion1);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: BillListItem) {
    return row && row.id ? `/accounting/acGeneralBill/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'General Bill List';
  };
  
  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const selectedBillNo = (context.data?.find(x => x.id === rowId) as BillListItem).billNo;

    function onPopupClose() {
      const storageKey = `bill-information-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen title={`Bill # : ${selectedBillNo}`} width="700px">
        <BillInformation billId={rowId} storageKey={`bill-information-${rowId}`} onPopupClose={onPopupClose} isView={false} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.GBill} keyProp='id' showFixLockedData={false} showAdjustBalance={true} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default GeneralBillListView;
